module.exports = __webpack_public_path__ + "static/chestnut-5969a358258c5c9d8d0de388045f1fd3.svg";